// ポリシーページのタイトルを英語に変更
document.addEventListener('DOMContentLoaded', function() {
  const policyTitle = document.querySelector('.shopify-policy__title h1');

  if (policyTitle) {
    const currentPath = window.location.pathname;

    // URLに基づいてタイトルを設定
    if (currentPath.includes('/terms-of-service') || currentPath.includes('/terms')) {
      policyTitle.textContent = 'TERMS OF SERVICE';
    } else if (currentPath.includes('/privacy-policy') || currentPath.includes('/privacy')) {
      policyTitle.textContent = 'PRIVACY POLICY';
    } else if (currentPath.includes('/refund-policy') || currentPath.includes('/refund')) {
      policyTitle.textContent = 'REFUND POLICY';
    } else if (currentPath.includes('/shipping-policy') || currentPath.includes('/shipping')) {
      policyTitle.textContent = 'SHIPPING POLICY';
    } else if (currentPath.includes('/legal-notice')) {
      policyTitle.textContent = 'LEGAL NOTICE';
    }
  }
});
